import {AmountMetaValueInterface} from './contracts/amount-meta-value.interface';

export class AmountMetaValue implements AmountMetaValueInterface {
  num: number;

  constructor(num: number) {
    this.num = num;
  }
}
